module.exports = __webpack_public_path__ + "img/home_21.83db7124.jpg";